import { snapToFrame } from '@schnitt/shared';
import { anDieReihe } from './einfuegeWarteschlange';
import { hochladen } from './hochladen';
import { useEditor } from './store';

/**
 * **Erst aussuchen, dann die Stelle** (Sascha, 17. Oktober: „Die [Plus]
 * könnten erst kommen, wenn man die Medien ausgewählt hat und sich der
 * Dialog wieder schließt. Dann fragt es mit den + Zeichen, wo eingefügt
 * werden soll“).
 *
 * Was auf seine Stelle wartet, kommt hierher: auf diese Spur (oder, ohne
 * Spur, auf die passende), an diese Sekunde. Vom Gerät wird erst jetzt
 * hochgeladen; aus den Medien geht es an die Reihe wie beim Einfügen am Plus
 * (7.241) -- was dahinter liegt, rückt nach.
 */
export function platziere(bei: number, trackId: string | null): void {
  const s = useEditor.getState();
  const p = s.platzieren;
  if (!p) return;
  const b = snapToFrame(Math.max(0, bei), s.timeline.settings.fps);
  s.setPlatzieren(null);
  s.setPlayhead(b);
  if (p.art === 'geraet') void hochladen(p.dateien, b, trackId);
  else anDieReihe(p.assetIds, b, trackId);
}

/** Vom Gerät, aber doch nur in die Medien. */
export function nurZuDenMedien(): void {
  const s = useEditor.getState();
  const p = s.platzieren;
  if (!p) return;
  s.setPlatzieren(null);
  if (p.art === 'geraet') void hochladen(p.dateien, null);
}
